import type { InitDisclosureSettingDTO } from '../service/ai-disclosure.repository.interface';
import type { GoalSettings, BaseRequest } from '../type/ai-disclosure.type';
import { injectable, inject } from '@patsnap/tahiti-core/shared/inversify';
import { InitDisclosureSetting } from '@/infrastructure/api-functions/interface/init-disclosure-setting.interface';

@injectable()
export class InitDisclosureSettingDTOImpl implements InitDisclosureSettingDTO {
    constructor(
        @inject(InitDisclosureSetting)
        private readonly _initDisclosureSettingApi: InitDisclosureSetting
    ) {
    }

    async fetch(value: GoalSettings & BaseRequest): Promise<void> {
        const params = {
            invention_subject: value.inventionSubject,
            application_field: value.applicationField,
            tech_means: value.techMeans,
            tech_effect: value.techEffect,
            other: value.other,
            task_id: value.taskId,
            current_step: value.currentStep,
        };

        await this._initDisclosureSettingApi.initDisclosureSetting(params);
    }
}
